(() => {
  if (window.Shopify?.designMode) return;
  let opened = false;
  const observer = new MutationObserver(openCalendar);
  const timeout = window.setTimeout(() => observer.disconnect(), 15000);
  function openCalendar() {
    const button = document.getElementById('apntly-book-button');
    if (opened || !button || !button.getClientRects().length) return;
    opened = true;
    observer.disconnect();
    window.clearTimeout(timeout);
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => button.click()));
  }
  observer.observe(document.body, {childList: true, subtree: true});
  openCalendar();
})();